export const handlePaginationList = (page, rowsPerPage, list) => {
    let startIndex = page * rowsPerPage;
    let lastIndex = startIndex + rowsPerPage;
    let paginatedList = list?.slice(startIndex, lastIndex);
    return paginatedList;
}

export const updateTableSortConfigObject = (configObject, isSortByAsc, currentSortBy, nextSortBy) => {
    let newHeadingArray = configObject.headings.map(item => {
        if (item.headingLabel === nextSortBy && nextSortBy !== "Actions") {
            item.icon = isSortByAsc ? "sort-alpha-down" : "sort-alpha-up";
        } else {
        //if (nextSortBy !== currentSortBy && item.headingLabel === currentSortBy && nextSortBy !== "Actions") {
            item.icon = "";
        }
        return item;
    });
    delete configObject.headings
    configObject.headings = newHeadingArray;
    return configObject;
}

const episodeNumberSort = (a, b, isSortByAsc) => {
    const epA = Number(String(a['episode_number'] || '').replace(/\D/g, ''));
    const epB = Number(String(b['episode_number'] || '').replace(/\D/g, ''));
    return isSortByAsc ? epA - epB : epB - epA;
};

export const showSeasonTableSortList = (type, typeField, list, isSortByAsc) => {
     let sortedList;
     switch (type) {
     case "Name":
         sortedList = list?.sort((a, b) => {
        const aValue = a[typeField];
        const bValue = b[typeField];
        if (aValue === null && bValue !== null) return isSortByAsc ? -1 : 1;
        if (bValue === null && aValue !== null) return isSortByAsc ? 1 : -1;
        if (aValue === null && bValue === null) return episodeNumberSort(a, b, isSortByAsc);
        const aName = aValue.toString().split(' ').join('').toLowerCase();
        const bName = bValue.toString().split(' ').join('').toLowerCase();
        let result;
        if (isSortByAsc) {
            result = aName > bName ? 1 : aName < bName ? -1 : 0;
        } else {
            result = bName > aName ? 1 : bName < aName ? -1 : 0;
        }
        return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
       });
       break;
    case "Date":
         sortedList = list?.sort((a, b) => {
         const rawA = a[typeField];
         const rawB = b[typeField];
       const isNullA = rawA == null || rawA === 'None';
        const isNullB = rawB == null || rawB === 'None';
         if (isNullA && !isNullB) return isSortByAsc ? -1 : 1;
         if (!isNullA && isNullB) return isSortByAsc ? 1 : -1;
         if (isNullA && isNullB) return episodeNumberSort(a, b, isSortByAsc);
         const parsedDateA = new Date(rawA);
         const parsedDateB = new Date(rawB);
         const result = isSortByAsc ? parsedDateA - parsedDateB : parsedDateB - parsedDateA;
         return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
        });
        break;
     
        case "Number":
         sortedList = list?.sort((a, b) => {
             const numA = Number(String(a[typeField] || '').replace(/\D/g, ''));
             const numB = Number(String(b[typeField] || '').replace(/\D/g, ''));
             const result = isSortByAsc ? numA - numB : numB - numA;
             return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
         });
         break;
         case "Boolean":
          sortedList = list?.sort((a, b) => {
             const valA = Number(Boolean(a[typeField]));
             const valB = Number(Boolean(b[typeField]));
             const result = isSortByAsc ? valA - valB : valB - valA;
             return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
         });
         break;
        }
        return sortedList;
    }   
export const tableSortList = (type, typeField, list, isSortByAsc) => {
    let sortedList;
    switch (type) {
        case "Name":
        if (isSortByAsc) {
                sortedList = list?.sort((a, b) => (a[typeField]?.toString().split(' ').join('').toLowerCase() > b[typeField]?.toString().split(' ').join('').toLowerCase()) ? 1 : -1);
            } else {
                sortedList = list?.sort((a, b) => (b[typeField]?.toString().split(' ').join('').toLowerCase() > a[typeField]?.toString().split(' ').join('').toLowerCase()) ? 1 : -1);
        }
            break;

        case "Date":
            if (isSortByAsc) {
                sortedList = list?.sort((a, b) => (Date.parse(a[typeField]?.toString().trim()) > Date.parse(b[typeField]?.toString().trim())) ? 1 : -1);
            } else {
                sortedList = list?.sort((a, b) => (Date.parse(b[typeField]?.toString().trim()) > Date.parse(a[typeField]?.toString().trim())) ? 1 : -1);
            }
            break;
        case "Number":
            if (isSortByAsc) {
                sortedList = list?.sort((a, b) => {
                    const numA = (a[typeField] || '').replace(/\D/g, '');
                    const numB = (b[typeField] || '').replace(/\D/g, '');
                    return numA.localeCompare(numB);
                });
            } else {
                sortedList = list?.sort((a, b) => {
                    const numA = (a[typeField] || '').replace(/\D/g, '');
                    const numB = (b[typeField] || '').replace(/\D/g, '');
                    return numB.localeCompare(numA);
                });
            }
         break; 
    }
    return sortedList;
}

/**
 * Sort function for Quick View grids.
 * Supports: "Name" (stable localeCompare), "Number" (true numeric),
 * "Date" (NaN-safe, empty treated as earliest), "CountThenAlpha"
 * (sort by item count, then alphabetically by first item).
 *
 * @param {string} type        - Sort type: Name | Number | Date | CountThenAlpha
 * @param {string} typeField   - Row object key to sort by
 * @param {Array}  list        - Array of row objects (will be sorted in place)
 * @param {boolean} isSortByAsc - true = ascending
 * @param {Object} [options]   - { separator } for CountThenAlpha (default '\n')
 */
export const quickViewSortList = (type, typeField, list, isSortByAsc, options = {}) => {
    switch (type) {
        case "Name":
            return list?.sort((a, b) => {
                const aVal = (String(a[typeField] || '')).trim().toLowerCase();
                const bVal = (String(b[typeField] || '')).trim().toLowerCase();
                return isSortByAsc ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
            });
        case "Date":
            return list?.sort((a, b) => {
                const aDate = Date.parse(String(a[typeField] || '').trim());
                const bDate = Date.parse(String(b[typeField] || '').trim());
                const aEmpty = isNaN(aDate);
                const bEmpty = isNaN(bDate);
                if (aEmpty && bEmpty) return 0;
                if (aEmpty) return isSortByAsc ? -1 : 1;
                if (bEmpty) return isSortByAsc ? 1 : -1;
                return isSortByAsc ? aDate - bDate : bDate - aDate;
            });
        case "Number":
            return list?.sort((a, b) => {
                const numA = parseFloat((String(a[typeField] || '0')).replace(/[^0-9.]/g, '')) || 0;
                const numB = parseFloat((String(b[typeField] || '0')).replace(/[^0-9.]/g, '')) || 0;
                return isSortByAsc ? numA - numB : numB - numA;
            });
        case "CountThenAlpha": {
            const sep = options.separator || '\n';
            return list?.sort((a, b) => {
                const itemsA = a[typeField] ? a[typeField].split(sep).filter(Boolean) : [];
                const itemsB = b[typeField] ? b[typeField].split(sep).filter(Boolean) : [];
                if (itemsA.length !== itemsB.length) return isSortByAsc ? itemsA.length - itemsB.length : itemsB.length - itemsA.length;
                const nameA = (itemsA[0] || '').replace(/^\d+\.\s*/, '').toLowerCase();
                const nameB = (itemsB[0] || '').replace(/^\d+\.\s*/, '').toLowerCase();
                return isSortByAsc ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
            });
        }
        case "CustomOrder": {
            // options.order: array defining the explicit sort priority, e.g. ['S','M','SM','G']
            const order = options.order || [];
            return list?.sort((a, b) => {
                const idxA = order.indexOf(String(a[typeField] || ''));
                const idxB = order.indexOf(String(b[typeField] || ''));
                const rankA = idxA === -1 ? order.length : idxA;
                const rankB = idxB === -1 ? order.length : idxB;
                return isSortByAsc ? rankA - rankB : rankB - rankA;
            });
        }
        default:
            return list;
    }
}

export const applyFilterTable = (config, data, filterValues, filtersNone) => {
    var finalList = [];
    var finalResult = [];
    var primaryKey = config.primaryKey;
    if (!filtersNone) {

        filterValues.map((filter) => {
            var keyValue = filter.split(":");
            var name = keyValue[0].trim();
            var value = keyValue[1].trim().toLowerCase();

            var index = -1; // Object.keys(config?.headings).indexOf((item) => config?.headings[item].headingLabel == name);

            Object.keys(config?.headings).map((item) => {
                console.log(config?.headings[item])
                if (config?.headings[item].headingLabel == name) {
                    index = item;
                    return;
                }
            });

            var nodeName = config?.dataNodes[index];
            var filteredList = data?.filter((item) => item[nodeName] != null ? item[nodeName].toString().toLowerCase().indexOf(value) > -1 : false);
            finalResult = finalResult.concat(filteredList?.filter((list) => !finalResult.find(p => p[primaryKey] == list[primaryKey])));

        });
    }
    else {
        finalResult = data;
    }
    //this.setState({filteredList : finalResult});    
    return finalResult;
   }